import { SEVERITY } from "helpers/utils.js";
import {
  GET_PACKAGINGS,
  GET_PACKAGINGS_SUCCESS,
  GET_PACKAGING_BY_ID_SUCCESS,
  GET_PACKAGINGS_ERROR,
  PACKAGING_CLEAR_ERROR,
  GET_PACKAGING_BY_ID,
  ADD_NEW_PACKAGING,
  UPDATE_PACKAGING,
  DELETE_PACKAGING,
  SAVE_PACKAGING_ENTRY_FORM_SUCCESS,
  GET_PACKAGING_ENTRY_FORM_SUCCESS,
  GET_PACKAGING_ENTRY_FORM,
  SAVE_PACKAGING_ENTRY_FORM,
} from "./actionTypes.js"
import { GET_SEWING_ENTRY_FORM_SUCCESS, SAVE_SEWING_ENTRY_FORM_SUCCESS } from "../sewing/actionTypes"
const initState = {
  items: [],
  item: null,
  summary: null,
  clothingSizes: [],
  purchaseOrderItems: [],
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const sewing = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PACKAGING_ENTRY_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case SAVE_PACKAGING_ENTRY_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        message: {
          title: "Packaging Form",
          text: "Packaging Entries have been saved successfully",
          severity: SEVERITY.SUCCESS,
        },
      }
      
    case GET_PACKAGING_ENTRY_FORM:
    case SAVE_PACKAGING_ENTRY_FORM:
    case DELETE_PACKAGING:
    case ADD_NEW_PACKAGING:
    case UPDATE_PACKAGING:
    case GET_PACKAGINGS:
      return {
        ...state,
        loading: true,
        // item: null,
      };
    case GET_PACKAGINGS_SUCCESS:
      const { itemCount, pageCount, data, clothingSizes, purchaseOrderItems, summary } =
        payload;
      return {
        ...state,
        itemCount,
        pageCount,
        clothingSizes,
        purchaseOrderItems,
        summary,
        items: data,
        // item: null,
        loading: false,
      };
    case GET_PACKAGING_BY_ID:
      return {
        ...state,
        item: null,
      };
    case GET_PACKAGING_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_PACKAGINGS_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_ItemUnitOfMeasurement");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Unit of Measurement already exist." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case PACKAGING_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default sewing;
